import { render } from "./PdfViewerModal.vue?vue&type=template&id=753abd56&scoped=true"
import script from "./PdfViewerModal.vue?vue&type=script&lang=js"
export * from "./PdfViewerModal.vue?vue&type=script&lang=js"

import "./PdfViewerModal.vue?vue&type=style&index=0&id=753abd56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753abd56"]])

export default __exports__